import { render, staticRenderFns } from "./DisplayJsonField.vue?vue&type=template&id=4c06ad30&"
import script from "./DisplayJsonField.vue?vue&type=script&lang=js&"
export * from "./DisplayJsonField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})
